import React, {
  useEffect,
  useState,
} from 'react';

import { classesAPI } from 'api/classesAPI';
import { cloneDeep } from 'lodash';
import {
  useLocation,
  useNavigate,
} from 'react-router-dom';
import {useRecoilState, useRecoilValue, useSetRecoilState} from 'recoil';
import {
    Alert,
    isAdmin,
    publishState,
} from 'state';
import styled, {keyframes} from 'styled-components';
import { isEmpty } from 'util/isEmpty';

import BtnIcon from '../../../assets/images/icon/menu.png';
import LogoImg from '../../../assets/images/logo.png';
import {coachingAPI} from "../../../api/coachingAPI";
import dayjs from "dayjs";
import {useWindowDimensions} from "../../../hooks/useWindowDimensions";

interface StyledComponentProps {
    active?: boolean;
    display?: boolean;
    
}
interface SideMenuProps {
    onClick?: any;
    selected: any;
    loading?: any
}

const arr = ["Details", "Overview", "Learning material", "Videos", "Quiz", "Instructor message"];
const coachingArr = ["Details", "Products", "About", "Showcase", "Testimonials"];

const fadeIn = keyframes`
  from {
    transform: translateX(-15px); 
  }

  to {
    transform: translateX(0); 
  }
`;

const isMobile = window.innerWidth < 768;
const SideMenu:React.FC<SideMenuProps> = ({onClick, selected, loading = false}) => {
    const navigate = useNavigate()
    const location = useLocation();
    const firstPathSegment = location.pathname.split('/')[1] === 'create_coaching';
    const [publishData, setPublishData] = useRecoilState(publishState);
    const admin = useRecoilValue(isAdmin);
    const [step, setStep] = useState(null)
    const [active, setWidth] = useState( !isMobile);
    const [submitActive, setSubmitActive] = useState(false);
    const {width, height} = useWindowDimensions()
    const setAlert = useSetRecoilState(Alert)
    const onClickMenu = (item:string, ) => {
        onClick(item.toLocaleLowerCase())
        if(width < 768){
            setWidth(false);
        };
    };
    const onClickSubmitButton = async () => {       
        if (firstPathSegment) {
          console.log('The first path segment is create_coaching');
            if(admin){
                await postAdminData();
            }else{
                await submitCoaching();
            }
        } else {
          console.log('The first path segment is not create_coaching');
            if(!isEmpty(location?.state?.createId)){
                if(admin){
                    await postAdminData();
                }else{
                    if(submitActive === true){
                        await classesAPI.postClassSubmit(location?.state?.createId)
                            .then(res => {
                                navigate("/")
                                setAlert({
                                    isActive:true,
                                    text:"Your work has been successfully submitted. Thank you!",
                                    desc:"",
                                    type:"info",
                                    color:"green",
                                    time:1300
                                })
                            })
                    }
                }
            }
        }
    };

    const submitCoaching = async () => {
        await coachingAPI.postSubmitCoaching(location?.state?.createId)
            .then(res => {
                navigate("/main/coaching")
            })
    }

    const postAdminData = async () => {
        const c = cloneDeep(publishData)
        c.publishDateTime = dayjs(publishData.publishDateTime).format("YYYY-MM-DDTHH:mm:ss")
        if (firstPathSegment) {
            await coachingAPI
                .postAdminSubmitCoaching(location?.state?.createId, {
                    data:{...cloneDeep(c)}
                })
                .then(async (res) => {
                    console.log("adminData@@", res);
                    navigate("/main/coaching")
                });
        }else{
            await classesAPI
                .postAdminClass(location?.state?.createId, {
                    data:{...cloneDeep(c)}
                })
                .then((res) => {
                    console.log("adminData@@", res);
                    navigate("/main/classes")

                });
        }

    };

    console.log('publsiheData', publishData)
    const checkStep = async () => {
        if(firstPathSegment){
            await coachingAPI.getProductStep(location?.state?.createId)
                .then((res) => {
                    const d = {...res?.data}
                    const data = Object.entries(d).find(item => {
                        return item[1] === false;
                    })
                    // setSubmitActive(data !== -1)
                    setStep(res?.data);
                    setSubmitActive(data === undefined);
                    console.log('object', data);
                })
        }else{
            await classesAPI.getClassStepById(location?.state?.createId)
                .then((res) => {
                    const d = {...res?.data}
                    const data = Object.entries(d).find(item => {
                        return item[1] === false && item[0] !== "quiz";
                    });
                    setStep(res?.data)
                    // setSubmitActive(data !== -1)
                    setSubmitActive(data === undefined)
                    console.log('object', data)
                })
        }

    }

    useEffect(()=>{
        checkStep()
    },[selected, location?.state?.createId, loading])
    
    console.log("@step",step);

    const arr2 = ["Details", "Overview", "Learning material", "Videos", "Quiz", "Instructor message"];
    const arr3 = ["Details", "Products", "About", "Showcase", "Testimonials"];

    const returnClassActiveState = (menu) => {
        if(step == null) return false;
        if(firstPathSegment) {
            switch (menu) {
                case "about" : {
                    return step["about"]
                }
                case "details" : {
                    return step["details"]
                }
                case "products" : {
                    return step["products"]
                }
                case "showcase" : {
                    return step["showcase"]
                }
                case "testimonials" : {
                    return step["testimonials"]
                }
            }
        };
        console.log("@menu",menu);
        switch (menu) {
            case "details" : {
                return step["details"]
            }
            case "overview" : {
                return step["overView"]
            }
            case "learning material" : {
                return step["learningMaterial"]
            }
            case "videos" : {
                return step["video"]
            }
            case "quiz" : {
                return step["video"]
            }
            case "instructor message" : {
                return step["video"]
            }
        }
    }
        
return(
  <Container active={active}>
    <Logo display={active}
        onClick={()=>{
            navigate("/main/classes")
        }}
    >
        <img src={LogoImg} alt="" />
    </Logo>
    <Menu>
        <MenuBtn className={!active ? "close" : ""} onClick={()=> setWidth(v => !v)}>
            <img src={BtnIcon} alt="" />
        </MenuBtn>
        {
            active && (firstPathSegment ? coachingArr : arr)?.map(item => {
                console.log("@status",returnClassActiveState(item.toLocaleLowerCase()));
                return(
                    <MenuItem onClick={() => {
                        onClickMenu(item)
                    }}
                              display={active}
                              className={`
                              ${selected === item.toLocaleLowerCase() ? "selected" : ""}
                              ${returnClassActiveState(item?.toLocaleLowerCase()) ? "on" : ""}`}>
                        <Circle/>
                        <span>
                    {item}
                </span>
                    </MenuItem>
                )
            })
        }
    </Menu>

    <Submit display={active} 
            style={{
                top:firstPathSegment ? 380 : 440
            }}            
            onClick={onClickSubmitButton} className={submitActive ? "on" : ""}>        
       <span>{admin ? "Publish" : "Submit"}</span>            
    </Submit>    
  </Container>
)

}
export { SideMenu };

const Container = styled.div<StyledComponentProps>`
    transition: all 0.3s;
    width: ${props => props.active ? 289 : 72}px;
    height: 100vh;
    background: #fff;
    border-right: solid 1px rgba(51, 51, 51, 0.3);
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 999999;
    @media screen and (max-width: 768px) {
        width: ${props => props.active ? "50%" : 0}px;
        padding: 0;
    }
`;

const Logo = styled.div<StyledComponentProps>`
    width: 90%;
    display: flex;
    justify-content: center;
    padding: 32px 0;
    border-bottom: solid 2px rgba(51, 51, 51, 0.1);
    opacity: ${props => !props.display ? 0 : 1};

    img{
        display: block;
        width: 180px;
        height: 37px;
        object-fit: cover;
        transform: scale(0.8);
        transform-origin: center;
    }
`; 
const Menu = styled.div`
    width: 298px;
    padding :10px 40px;
`; 
const MenuItem = styled.div<StyledComponentProps>`
    transition: all 0.5s;    
    transform: translateX(${props => !props.display ? "-40px" : "none"});
    &.on{
        opacity: 1;
        pointer-events: all;
    }
    pointer-events: none;
    opacity: 0.6;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 20px 0;
    &:last-child{
        padding-bottom: 0px!important;
    }

    span{
        font-size: 20px;
        display: flex;
        height: 16px;
        align-items: center;
        margin-left: 4px;
    }
`; 
const Circle = styled.div`
    transition: all 0.2s;
    .selected & {
        border: solid 4px #DDC160;
    }
    width: 16px;
    height: 16px;
    margin-right: 8px;
    border-radius: 8px;
    border: solid 1px #333;
`;
const MenuBtn = styled.div`
    position: absolute;
    transition: all 0.2s;
    width: 40px;
    height: 40px;
    right: 0px;
    top: 100px;
    cursor: pointer;
    transform: translate(50%, -50%);
    img{
        display: block;
        width: 100%;
        height: 100%;
    }
    @media screen and (max-width: 768px) {
        top: 30px;
        &.close{
            right: calc(100% - 30px);
        }
    }
`; 

const Submit = styled.div<StyledComponentProps>`
    transition: all 0.3s;    
    transform: translateX(${props => !props.display ? "-160px" : "none"});
    opacity: ${props => !props.display ? 0 : 1};
    position: absolute;
    top: 440px;
    margin-top: 20px;
   
    span{       
        transition: all 0.3s;    
        .on&{
            background: #ddc160;
            color: #fff;
        }
        cursor: pointer;
        background: #E5E5E5;
        width: 220px;
        height: 40px;
        border-radius: 8px;
        color:"#333";
        display: flex;
        align-items: center;
        justify-content: center;
       
    }
`; 